import { BulkTicketChangeJob } from '../../services/tickets/tickets';
import { getLocalStorageItem, setLocalStorageItem, StorageHelperKeys } from '../../utils/storageHelpers';
import { BULK_TICKET_CHANGE_JOB_FINISH_EVENT, BULK_TICKET_CHANGE_JOB_START_EVENT } from './constant';

function fireBulkTicketChangeJobFinishEvent() {
    window.dispatchEvent(
        new CustomEvent<BulkTicketChangeJobFinishEvent>(BULK_TICKET_CHANGE_JOB_FINISH_EVENT, {
            detail: { isFinished: true },
            bubbles: true
        })
    );
}
function fireBulkTicketChangeJobStartEvent(jobId: string) {
    window.dispatchEvent(
        new CustomEvent<BulkTicketChangeJobStartEvent>(BULK_TICKET_CHANGE_JOB_START_EVENT, {
            detail: { jobId },
            bubbles: true
        })
    );
}

const getJobFeedbacksOnStorage = (): BulkTicketChangeJob[] =>
    getLocalStorageItem(StorageHelperKeys.BULK_TICKET_CHANGE_JOB_LIST) ?? [];

const setJobFeedbacksToStorage = (newJobList: BulkTicketChangeJob[] = []): void =>
    setLocalStorageItem(StorageHelperKeys.BULK_TICKET_CHANGE_JOB_LIST, newJobList);

export {
    fireBulkTicketChangeJobFinishEvent,
    fireBulkTicketChangeJobStartEvent,
    getJobFeedbacksOnStorage,
    setJobFeedbacksToStorage
};
